import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { MobileBottomBar } from './components/MobileBottomBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TrustBar } from './components/TrustBar';
import { RecentShipments } from './components/RecentShipments';
import { CtaBanner } from './components/CtaBanner';
import { HowItWorks } from './components/HowItWorks';
import { DealDirect } from './components/DealDirect';
import { Pricing } from './components/Pricing';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  // Load LeadConnector number-pool call tracking so every tel: link and
  // displayed phone number is swapped to a unique tracking number per visitor.
  useEffect(() => {
    const SRC = 'https://backend.leadconnectorhq.com/appengine/loc/IExKC1X6hwJ1fw7H9LRY/pool/YoC0nU8hlKPCiAO1vaF2/number_pool.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <TrustBar data-id="element-5" />
        <RecentShipments data-id="element-6" />
        <CtaBanner heading="Get a free, no-obligation heavy equipment transport quote in minutes" data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <DealDirect data-id="element-9" />
        <Pricing data-id="element-10" />
        <CtaBanner heading="Ready for a fixed quote from a real heavy-haul carrier?" data-id="element-11" />
        <WhyChooseUs data-id="element-12" />
        <Services data-id="element-13" />
        <Testimonials data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <MobileBottomBar data-id="element-18" />
    </div>;
}